import { useMemo, useState } from 'react';

import { useAppSelector } from 'hooks';

import {
  SimpleGrid,
  Box,
  Collapse,
  Button,
  Icon,
  useColorModeValue,
  Flex,
} from '@chakra-ui/react';

import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

const Convictions = ({ index }: { index: number }) => {
  const [isConvictionsCollapsed, setIsConvictionsCollapsed] = useState(true);

  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const convictions = useAppSelector(
    (state) => state.autoPersonalForm.data.convictions,
  );

  const filteredConvictions = useMemo(() => {
    return convictions.filter(
      (conviction) => conviction.driver_nr === index + 1,
    );
  }, [convictions, index]);

  return (
    <Box p="20px" py="10px" borderTop="1px solid" borderColor={borderColor}>
      <Box>
        <Flex justifyContent="space-between" alignItems="center">
          <Box fontWeight="bold" fontSize="l">
            {`Convictions (${filteredConvictions.length})`}
          </Box>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsConvictionsCollapsed(!isConvictionsCollapsed)}
            rightIcon={
              <Icon
                as={isConvictionsCollapsed ? ChevronDownIcon : ChevronUpIcon}
              />
            }
          >
            {isConvictionsCollapsed ? 'Show Convictions' : 'Hide Convictions'}
          </Button>
        </Flex>
        <Collapse in={!isConvictionsCollapsed} animateOpacity>
          {filteredConvictions.length === 0 ? (
            <Box p={2} color="gray.500">
              No convictions for driver reported on the quote
            </Box>
          ) : (
            <Box>
              <SimpleGrid
                columns={1}
                borderTop="1px solid"
                borderColor={borderColor}
                mt={2}
              >
                <Flex p={2} bg="gray.50" fontWeight="semibold">
                  <Box w="150px">Date</Box>
                  <Box flex="1">Details</Box>
                </Flex>
                {filteredConvictions.map((conviction, convictionIndex) => (
                  <Flex
                    key={convictionIndex}
                    p={2}
                    pb={
                      convictionIndex < filteredConvictions.length - 1 ? 2 : 0
                    }
                    borderBottom={
                      convictionIndex < filteredConvictions.length - 1
                        ? '1px solid'
                        : ''
                    }
                    borderColor={borderColor}
                    alignItems="center"
                  >
                    <Box w="150px">{conviction.date}</Box>
                    <Box flex="1">
                      {conviction.details || 'No details provided'}
                    </Box>
                  </Flex>
                ))}
              </SimpleGrid>
            </Box>
          )}
        </Collapse>
      </Box>
    </Box>
  );
};

export default Convictions;
